import Instance from "../../../../Axios";

// New Actions for the app

const GetGraficoObrasSemana= () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras/graficoObrasSemana`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_GRAFICO_OBRAS_SEMANA", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetGraficoObrasSemana;